import multiGuard from '@/router/utils/vue-router-multiguard'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'
import b2bAddonGuard from '@/router/guards/b2b-addon-guard'

export default [
  {
    path: '',
    name: 'admin:b2b',
    beforeEnter: multiGuard([b2bAddonGuard]),
    meta: {
      permission: [
        SUBUSER_PERMISSION_SLUGS.B2B_VIEW,
        SUBUSER_PERMISSION_SLUGS.B2B_MANAGE,
        SUBUSER_PERMISSION_SLUGS.B2B_DELETE,
      ],
    },
    component: () => import(/* webpackChunkName: "b2b" */ '@/views/admin/b2b/B2bDashboard.vue'),
  },
]
